module.exports = __webpack_public_path__ + "assets/img/customerService-733e2e76.png";